import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SanitizeHtml from 'sanitize-html';

export class GoogleAttributionItem extends Component {
    sanitizeAttribution(attribution){
        return SanitizeHtml(attribution, {
            allowedTags: [ 'b', 'i', 'em', 'strong', 'a' ],
            allowedAttributes: {
                'a': [ 'href' ]
            }
        });
    }

    render(){
        const { item } = this.props;
        return (
            <div className="google-address-attribution-item" dangerouslySetInnerHTML={{__html: this.sanitizeAttribution(item)}}></div>
        );
    }
}

GoogleAttributionItem.propTypes = {
    item: PropTypes.string
};

export default GoogleAttributionItem;
